// eslint-disable-next-line no-unused-vars
import { Children, cloneElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  useGetLogisticTaskIdQuery,
  useGetLogisticTaskStatusQuery,
  usePatchLogisticTaskMutation,
  useStopLogisticTasksMutation,
  usePatchLogisticTaskSolveMutation,
  useGetLogisticStatesInitialQuery,
} from '../redux/logisticTasks.api';
// eslint-disable-next-line boundaries/element-types
import { usePostVehicleRouteMutation } from '../../../vehicles/VehiclesRoute/vehiclesRoutes/redux/vehiclesRoutes.api';

// Компонента Бизнес уровня которая является связующим звеном между фронтом и бизнесом
// Компонента возвращает Children с новыми пропсами из бизнес уровня
function LogisticTaskBll({ children, logisticTaskId }) {
  const [taskStatus, setTaskStatus] = useState({ status: null });
  const logisticTask = useGetLogisticTaskIdQuery({
    id: logisticTaskId,
  });

  const [pollingInterval, setPollingInterval] = useState(0);
  const logisticTaskStatus = useGetLogisticTaskStatusQuery(
    {
      id: logisticTaskId,
    },
    {
      pollingInterval,
    },
  );

  const stopLogisticTask = useStopLogisticTasksMutation();

  // Данные перехватывает доп. редьюсер слайса logisticTasksBalanceSlice
  useGetLogisticStatesInitialQuery({ taskId: logisticTaskId }, { refetchOnMountOrArgChange: true });

  useEffect(() => {
    setTaskStatus({ status: logisticTaskStatus?.data });
  }, [logisticTaskStatus.data]);

  useEffect(() => {
    setTaskStatus({ status: logisticTask?.data?.status });
  }, [logisticTask.data]);

  const [patchLogisticTask, resultPatchLogisticTask] = usePatchLogisticTaskMutation();

  const [patchLogisticTaskSolve, solveLogisticTask] = usePatchLogisticTaskSolveMutation();

  const [postRouteRequest, postRouteResult] = usePostVehicleRouteMutation();

  const startPolling = (interval = 15000) => {
    setPollingInterval(interval);
  };

  const stopPolling = () => {
    setPollingInterval(0);
  };

  const props = {
    logisticTask,
    taskStatus,
    getLogisticTaskSolution: ({ body }) => patchLogisticTask({ body: { logisticTaskId, ...body }, id: logisticTaskId }),
    patchLogisticTask: ({ body }) => patchLogisticTask({ body: { logisticTaskId, ...body }, id: logisticTaskId }),
    resultPatchLogisticTask,
    patchLogisticTaskSolve: () => patchLogisticTaskSolve({ id: logisticTaskId }),
    postRouteRequest: ({ body }) => {
      postRouteRequest({ body });
    },
    postRouteResult: {
      ...postRouteResult,
    },
    solutionLogisticTask: {
      ...resultPatchLogisticTask,
    },
    solveLogisticTask: {
      ...solveLogisticTask,
    },
    startPolling,
    stopPolling,
    stopLogisticTask,
  };

  return logisticTask ? Children.toArray(children).map((child) => cloneElement(child, props)) : null;
}

LogisticTaskBll.propTypes = {
  children: PropTypes.element.isRequired,
  logisticTaskId: PropTypes.number.isRequired,
};

export default LogisticTaskBll;
